import axios from 'axios';
import { toast } from 'react-toastify';

console.log('API URL ++++++++++++++++++', process.env.GATSBY_API_URL);
axios.defaults.baseURL = process.env.GATSBY_API_URL;

axios.interceptors.response.use(null, (error) => {
  console.log('ERROR OCCURED - intercepter', error);
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    const errorMessage = error.response || error.message;

    toast.error(`An unexpected error occurrred: ${errorMessage}`);
  }

  return Promise.reject(error);
});

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
